export const videoModalViewed = (filename, heading) => ({
  type: 'Video Modal Viewed',
  data: {
    filename,
    heading,
  },
});
